// extracted by mini-css-extract-plugin
export var bodyRow = "_fg-d";
export var cardColumns = "_fg-e";
export var ellipsesOverflow = "_fg-2";
export var flatBottomCorners = "_fg-3";
export var flatTopCorners = "_fg-4";
export var headerActionsDropdown = "_fg-f";
export var headerBottomRow = "_fg-c";
export var headerTopRow = "_fg-b";
export var orderDetailsWrapper = "_fg-0";
export var orderInfoContainer = "_fg-1";
export var productDetails = "_fg-9";
export var productImage = "_fg-5";
export var responsiveTable = "_fg-8";
export var shipmentContainer = "_fg-a";
export var tableBottomLeft = "_fg-6";
export var tableBottomRight = "_fg-7";